export const stackCenterGap = {
  flex: 1,
};
